export default __webpack_public_path__ + "static/GokceTekin-e0a7496609b924e5423219fb0c15736d.png";